<template>
    <section class="mt-16">
        <v-breadcrumbs
          large
          :items="crumbs"
          divider="/"
          class="pl-0"
        ></v-breadcrumbs>
  
        <h1 class="primary--text">
          <v-icon color="primary">mdi-shape</v-icon> <span>{{$t('menu.categories_management')}}</span>
        </h1>
        <v-icon color="primary">
          mdi-eye
        </v-icon><v-icon class="ml-2" small>mdi-forward</v-icon>
        {{$t('globals.visualize')}}
  
        <v-icon color="red" class="ml-4">
          mdi-delete
        </v-icon><v-icon class="ml-2" small>mdi-forward</v-icon>
        {{$t('globals.remove')}}
  
        <div style="position:relative">
          <v-container>
            <v-speed-dial
              absolute
              v-model="speedDial"
              top
              right
              direction="bottom"
              :open-on-hover="true"
            >
              <template v-slot:activator>
                <v-tooltip right color="primary">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs" v-on="on"
                      v-model="speedDial"
                      color="primary"
                      dark
                      x-large
                      fab
                    >
                      <v-icon v-if="speedDial">
                        mdi-close
                      </v-icon>
                      <v-icon v-else>
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t('globals.options')}}</span>
                </v-tooltip>
              </template>
              <v-tooltip right color="info" v-if="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs" v-on="on"
                    fab
                    dark
                    small
                    color="info"
                    large
                    @click="searching = true"
                  >
                    <v-icon>mdi-filter</v-icon>
                  </v-btn>
                </template>
                <span>{{$t('globals.search')}}</span>
              </v-tooltip>
              <v-tooltip right color="secondary">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs" v-on="on"
                    fab
                    dark
                    small
                    color="secondary"
                    large
                    to="/admin/complaints/categories/create"
                    v-if="$root.session.hasPermission(['super', 'categories.create'])"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>{{$t('globals.register')}}</span>
              </v-tooltip>
            </v-speed-dial>
          </v-container>
  
          <v-data-table
            :headers="headers"
            :items="items"
            :server-items-length="total"
            :loading="loading"
            :footer-props="tableFooter"
            :options.sync="options"
            class="mt-16"
            locale="pt-pt"
          >

          <template v-slot:item.i18n="{item}">
              {{item.i18n[$i18n.locale]}}
            </template>
  
            <template v-slot:item.actions="{item}">
              <IconView
                class="mr-2"
                @click="viewCategory(item)"
              />
              <IconRemove
                class="mr-2"
                @on-submit="deleteCategory(item)"
              />
            </template>
          </v-data-table>
        </div>
        <v-navigation-drawer
            fixed
            right
            v-model="searching"
            hide-overlay
            width="520"
            class="pt-6"
          >
          <v-list>
            <v-list-item>
              <v-btn fab small color="secondary" @click="searching = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
  
              <v-btn absolute right small color="error" @click="resetCategory">
                {{$t('globals.clean_fields')}}
              </v-btn>
            </v-list-item>
          </v-list>
          <v-list class="pt-10">
            <v-form @submit.prevent="searchCategory">
              
              <v-list-item>
                <v-text-field
                  v-model="filter.code"
                  prepend-inner-icon="mdi-account-details"
                  label="Código"
                  clearable
                ></v-text-field>
              </v-list-item>
  
              <v-list-item>
                <v-text-field
                  v-model="filter.name"
                  prepend-inner-icon="mdi-account-details"
                  label="Nome"
                  clearable
                ></v-text-field>
              </v-list-item>
              <v-row
                class="mt-10"
                align="center"
                justify="space-around"
              >
              <v-btn
                color="primary"
                type="submit"
              >
              {{$t('globals.search')}}
              </v-btn>
              </v-row>
            </v-form>
          </v-list>
        </v-navigation-drawer>
    </section>
  </template>
  <script>
  import IconRemove from '@/components/ui/IconRemove.vue';
  import IconView from '@/components/ui/IconView.vue';
  import Category from "@/api/Category.js";
  import User from "@/api/User.js";
  
  export default {
    components: {
      IconRemove,
      IconView
    },
    watch: {
      'options': {
        immediate: false,
        handler () {
          setTimeout(() => {this.searchCategory()}, 10);
        },
        deep: true,
      },
    },
    beforeCreate(){
      document.title = this.$t('app_name')
  
   
    },
    data: () => ({
      items: [],
      total: 0,
      loading: false,
      searching: false,
      options: {},
      speedDial:false,
      filter: {
        code: null,
        name:null,
      },
      users:[]
    }),
    mounted(){
  
      if(!this.$root.session.hasPermission(["super", "categories.read"])) {
        this.$router.push('/admin');
      }
  
      User.list({is_active: 1}).then(({data}) => {
        this.users = data;
      });
  
      this.fillBaseData();
    },
    methods:{
      fillBaseData() {
  
        if(localStorage["categories-" + this.$root.session.id] != undefined){
  
          let data = JSON.parse(localStorage["categories-" + this.$root.session.id]);
  
          this.filter = data.filter;
  
          this.options = data.options;
        }
      },
      searchCategory(event){
        if(!!event && event.type == 'submit'){
          this.options.page = 1;
        }
  
        this.loading = true;
  
        let filter = {...this.filter};
  
        let request = {
          page: this.options.page,
          limit: this.options.itemsPerPage,
        };
      
        Object.assign(request, filter);
  
        localStorage["categories-" + this.$root.session.id] = JSON.stringify({
          filter: this.filter,
          options: this.options,
        });
  
        Category.search(request).then(response => {

          let data = response.data
  
          this.total = data.total;
  
          this.items = data.data.map((item) => {
  
            this.searching = false;
  
            return item;
          });
  
          this.loading = false;
  
        });
      },
      resetCategory()
      {
        this.filter = {};
  
        this.searchCategory();
      },
      viewCategory(item){
        this.$router.push('/admin/complaints/categories/' + item.id);
      },
      deleteCategory(item){
        Category.delete(item.id)
          .then(() => {
            this.searchCategory();
          });
      },
    },
    computed: {
      headers(){
        return [
          {
            text: this.$t('globals.reference'),
            sortable: false,
            value: 'reference',
          },
          {
            text: this.$t('globals.category'),
            sortable: false,
            value: 'i18n',
          },
          { 
            text: this.$t('globals.options'),
            value: 'actions', 
            sortable: false 
          },
        ]
      },
      tableFooter(){
        return {
          'items-per-page-options': [5, 10, 15, 20],
          'items-per-page-text': this.$t('globals.lines_per_page')
        }
      },
      crumbs: function() {
        return [
          {
            text: this.$t('menu.complaints_management'),
            disabled: true,
            exact: true,
          },
          {
            text: this.$t('menu.categories_management'),
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  